import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

export interface ContactDetails {
  givenName: string;
  surname: string;
  dateOfBirth: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  phoneNumber: string;
}

@Component({
    selector: 'app-contact-details',
    templateUrl: './contact-details.component.html',
    styleUrls: ['./contact-details.component.scss'],
    imports: [ReactiveFormsModule, IonicModule, TranslatePipe]
})
export class ContactDetailsComponent implements OnInit, OnDestroy {
  private formBuilder = inject(UntypedFormBuilder);

  @Input()
  public contactDetails: ContactDetails;

  @Input()
  public authenticated: boolean;

  @Input()
  public buttonText: string;

  @Input()
  public disclaimer: string;

  @Output()
  public save = new EventEmitter<ContactDetails>();


  @Output()
  public valid = new Subject<boolean>();

  public contactDetailsForm: UntypedFormGroup;
  private valueChangesSubscription: Subscription;

  constructor() {
    this.contactDetailsForm = this.formBuilder.group({
      givenName: ['', Validators.required],
      surname: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      street: ['', Validators.required],
      houseNumber: ['', Validators.required],
      zipCode: ['', Validators.required],
      city: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.contactDetailsForm.patchValue({
      givenName: this.contactDetails.givenName,
      surname: this.contactDetails.surname,
      dateOfBirth: this.contactDetails.dateOfBirth,
      phoneNumber: this.contactDetails.phoneNumber,
      street: this.contactDetails.street,
      houseNumber: this.contactDetails.houseNumber,
      zipCode: this.contactDetails.zipCode,
      city: this.contactDetails.city,
    });

    this.valueChangesSubscription = this.contactDetailsForm.valueChanges.pipe(
      tap(() => this.valid.next(this.contactDetailsForm.valid))
    ).subscribe();
  }

  ngOnDestroy() {
    this.valueChangesSubscription.unsubscribe();
  }

  public emitSave(): void {
    if (this.contactDetailsForm.valid) {
      this.save.emit(this.contactDetailsForm.value);
    }
  }

  public updateDateOfBirth(event: any) {
    const dateOfBirth = event.detail.value;
    this.contactDetailsForm.patchValue({
      dateOfBirth
    });
    this.contactDetailsForm.markAsDirty();
    this.contactDetailsForm.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }
}
